webpackJsonp([100667300852966],{

/***/ 126:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image1.08a1b975.jpg";

/***/ }),

/***/ 127:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image10.386f4d25.jpg";

/***/ }),

/***/ 128:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image11.b0d57148.jpg";

/***/ }),

/***/ 129:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image12.0ac641ab.jpg";

/***/ }),

/***/ 130:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image2.f0c55a6a.jpg";

/***/ }),

/***/ 131:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image3.13b03cc1.jpg";

/***/ }),

/***/ 132:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/image4.da66be46.jpg";

/***/ }),

/***/ 214:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(15);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactImageGallery = __webpack_require__(27);
	
	var _reactImageGallery2 = _interopRequireDefault(_reactImageGallery);
	
	__webpack_require__(25);
	
	var _image = __webpack_require__(126);
	
	var _image2 = _interopRequireDefault(_image);
	
	var _image3 = __webpack_require__(130);
	
	var _image4 = _interopRequireDefault(_image3);
	
	var _image5 = __webpack_require__(131);
	
	var _image6 = _interopRequireDefault(_image5);
	
	var _image7 = __webpack_require__(132);
	
	var _image8 = _interopRequireDefault(_image7);
	
	var _image9 = __webpack_require__(129);
	
	var _image10 = _interopRequireDefault(_image9);
	
	var _image11 = __webpack_require__(127);
	
	var _image12 = _interopRequireDefault(_image11);
	
	var _image13 = __webpack_require__(128);
	
	var _image14 = _interopRequireDefault(_image13);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AgeFriendlyCommunitiesPage = function AgeFriendlyCommunitiesPage() {
	    return _react2.default.createElement(
	        'div',
	        { className: 'container' },
	        _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	                'div',
	                { className: 'col-lg-5 project-info' },
	                _react2.default.createElement(
	                    'h3',
	                    null,
	                    'Capoeira: A Thick Description'
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'project-content' },
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'The human being is intertwined in a complex and thick \u2018system of meanings\u2018, which is called culture. Clifford Geertz (1926-present) is best known for his ethnographic studies of Javanese culture (Indonesian island) and for his writings about the interpretation of culture. The most influential aspect of Geertz\'s work has been his emphasis on the importance of the symbolic -- of systems of meaning -- as it relates to culture, cultural change, and the study of culture; notice this emphasis as you watch the ethnographical movie about Capoeira culture.'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'With Geertz\' method of thick description our research aimed to extract meaning structures that make up Capoeira and visualise it in an ethnographical movie. The narration (in German) describes in a very detailed way numerous Capoeira elements (Roda, movements, music and origin) and interprets their meanings by uncovering unspoken rules that the Capoeiristas follow every day.'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'Origin, the last element of the Capoeira video, contextualises the phenomenon and informs the audience about Capoeira\u2019s historical and social background. \u201CCapoeira as a culture of resistance\u201D is therefore not just a sport, it is history, life philosophy as well as     complex and thick \u2018systems of meanings\u2018, called culture.'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'Further information about the research will be provided upon request.'
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'col-lg-7' },
	                _react2.default.createElement('iframe', { width: '640', height: '360', src: '//www.youtube.com/embed/_6PoS-5tKyE', frameborder: '0', allowfullscreen: true }),
	                _react2.default.createElement('br', null),
	                _react2.default.createElement('br', null),
	                _react2.default.createElement(
	                    'p',
	                    { className: 'project-blurb' },
	                    'An ethnographical movie of Capoeira with the thick description method by Clifford Geertz.'
	                ),
	                _react2.default.createElement(
	                    'ul',
	                    { className: 'tags' },
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        'Participative Observation'
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        'Interviews'
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        'Thick Description'
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        'Ethnographical Movie'
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        'Capoeira'
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        'Clifford Geertz'
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        'Interpretation of Culture (1973)'
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        'Systems of meaning'
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'footer-info' },
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        _react2.default.createElement(
	                            'span',
	                            { className: 'highlight' },
	                            'Cooperation Partner:'
	                        ),
	                        ' Boosted Human, Cancer Council Victoria and Vic Health'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        _react2.default.createElement(
	                            'span',
	                            { className: 'highlight' },
	                            'Source:'
	                        ),
	                        ' Boosted Human'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        _react2.default.createElement(
	                            'span',
	                            { className: 'highlight' },
	                            'Date:'
	                        ),
	                        ' 2014 - Present'
	                    )
	                )
	            )
	        )
	    );
	};
	
	exports.default = AgeFriendlyCommunitiesPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-projects-capoeira-js-701b8d43d06483790def.js